// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "main.module." + {"634":"8e9e3961f0b16e5eb248","816":"2f13ce923df4d56fc0c7"}[chunkId] + ".js";
};